import axios from "axios";
import {authService} from "./authService";
import {API_URL} from "./config";
import {normalizeApiError} from "./apiError";

const createClient = () => axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

const $host = createClient();
const $authHost = createClient();

const rejectApiError = (error, fallbackMessage) => {
    return Promise.reject(normalizeApiError(error, fallbackMessage));
};

$host.interceptors.response.use(
    (response) => response,
    (error) => rejectApiError(error)
);

$authHost.interceptors.request.use(
    async (config) => {
        try {
            if (authService.getAccessToken() && authService.isTokenExpired(30)) {
                await authService.refreshAccessToken();
            }

            const token = authService.getAccessToken();
            if (token) {
                config.headers = config.headers || {};
                config.headers.authorization = `Bearer ${token}`;
            }

            return config;
        } catch (error) {
            return rejectApiError(error, 'Не удалось подготовить авторизованный запрос');
        }
    },
    (error) => rejectApiError(error)
);

$authHost.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const data = await authService.refreshAccessToken();
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.authorization = `Bearer ${data.access_token}`;
                return $authHost(originalRequest);
            } catch (refreshError) {
                authService.forceLogout('refresh_failed');
                return rejectApiError(refreshError, 'Сессия истекла. Войдите снова');
            }
        }

        return rejectApiError(error);
    }
);

export {
    $host,
    $authHost,
};
